/** Five notched sakura petals around (50, 50) — viewBox 0 0 100 100. */
export const SAKURA_PATH =
  'M50 50C47 45 37 37 35 25C33.5 14 40 7 46 9L50 13.5L54 9C60 7 66.5 14 65 25C63 37 53 45 50 50Z' +
  'M50 50C53.8 45.6 58.3 33.6 69.1 28C79.1 23.2 87.8 27.2 87.8 33.5L84.7 38.7L90.2 41.1C94 46.2 89.3 54.6 78.4 56.5C66.4 58.3 55.7 51.3 50 50Z' +
  'M50 50C55.4 52.3 68.2 52.9 76.8 61.4C84.5 69.4 83.4 78.9 77.3 80.8L71.5 79.5L70.9 85.5C67.2 90.7 57.8 88.8 52.6 79C47.1 68.2 50.5 55.8 50 50Z' +
  'M50 50C49.5 55.8 52.9 68.2 47.4 79C42.2 88.8 32.8 90.7 29.1 85.5L28.5 79.5L22.7 80.8C16.6 78.9 15.5 69.4 23.2 61.4C31.8 52.9 44.6 52.3 50 50Z' +
  'M50 50C44.3 51.3 33.6 58.3 21.6 56.5C10.7 54.6 6 46.2 9.8 41.1L15.3 38.7L12.2 33.5C12.2 27.2 20.9 23.2 30.9 28C41.7 33.6 46.2 45.6 50 50Z' +
  'M57 50A7 7 0 1 1 43 50A7 7 0 1 1 57 50Z';

/** A single notched petal, tip pointing down — viewBox 0 0 100 100. */
export const PETAL_PATH =
  'M50 94.3C43.6 83.6 22.1 66.4 17.8 40.6C14.5 16.9 28.5 1.9 41.4 6.2L50 15.8L58.6 6.2C71.5 1.9 85.5 16.9 82.3 40.6C78 66.4 56.5 83.6 50 94.3Z';
